<template>
  <section v-if="allowed && checkId && patientId" class="registration-revoke">
    <div><b>管理员操作</b><p>检测编号：{{checkId}}</p></div>
    <Button type="error" ghost :loading="busy" :disabled="busy || disabled" @click="confirmRevoke">撤销登记</Button>
    <Alert v-if="error" type="error" show-icon class="registration-revoke__error">{{error}}</Alert>
  </section>
</template>

<script>
import Qs from 'qs'
import { getToken } from '../utils/auth'
import { readEntryQuery } from '../utils/session'
import { clearRevokedRegistration } from '../utils/registrationRevoke'

export default {
  name: 'RegistrationRevokeAction',
  props: {
    checkId: { type: String, default: '' },
    patientId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data () { return { allowed: false, busy: false, error: '', permissionSequence: 0 } },
  created () { this.loadPermission() },
  beforeDestroy () { this.permissionSequence++ },
  watch: {
    '$route.fullPath' () { this.loadPermission() }
  },
  methods: {
    async loadPermission () {
      const sequence = ++this.permissionSequence
      const token = getToken()
      this.allowed = false
      try {
        const res = await this.$http.get('/h5/entry/permissions')
        if (sequence !== this.permissionSequence || getToken() !== token) return
        this.allowed = res.result === '1' && !!res.data && res.data.canRevokeRegistration === true
      } catch (error) { this.allowed = false }
    },
    setBusy (value) { this.busy = value; this.$emit('busy-change', value) },
    confirmRevoke () {
      if (!this.allowed || this.busy || this.disabled || !this.patientId || !this.checkId) return
      const target = { checkId: this.checkId, patientId: this.patientId, token: getToken(), envKey: readEntryQuery(this.$route).envKey || '' }
      this.setBusy(true)
      this.$Modal.confirm({
        title: '确认撤销登记',
        render: h => h('div', [h('p', '检测编号：' + target.checkId), h('p', '将撤销登记并解除检测人绑定，保留订单和历史记录。已送检或已有病例、报告的记录不能撤销。')]),
        onOk: () => this.revoke(target),
        onCancel: () => this.setBusy(false)
      })
    },
    async revoke (target) {
      this.error = ''
      try {
        if (this.disabled || !this.allowed || target.token !== getToken() || target.checkId !== this.checkId || target.patientId !== this.patientId) {
          throw new Error('账号或检测信息已变化，请重新确认')
        }
        const res = await this.$http.post('/patient/delPatInfoByCheckId', Qs.stringify({ checkId: target.checkId }))
        if (!res || res.result !== '1') throw new Error((res && (typeof res.data === 'string' ? res.data : res.desc)) || '撤销失败，请重试')
        if (target.token !== getToken()) throw new Error('账号已变化，请重新查询检测状态')
        clearRevokedRegistration(target.checkId, target.envKey)
        this.setBusy(false)
        this.$Message.success('登记已撤销')
        this.$emit('revoked', target.checkId)
      } catch (error) {
        this.error = error.message || '撤销请求失败，请重试'
      } finally { this.setBusy(false) }
    }
  }
}
</script>

<style scoped>
.registration-revoke { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; margin: 16px 0; padding: 16px; background: #fff; border: 1px solid #e8eaec; border-radius: 12px; }
.registration-revoke p { margin-top: 6px; word-break: break-all; }
.registration-revoke__error { width: 100%; margin: 0; }
</style>



// WEBPACK FOOTER //
// src/components/RegistrationRevokeAction.vue